import * as localforage from "localforage";
import axios from "axios";

export const getAllTagsAPI = async (should_return = false, hasSubCompanies) => {
  let response = await axios({
    url: `/api/v2/tag/all`,
    method: "GET",
    params: {
      hasSubCompanies
    }
  });
  if (should_return) {
    return response.data;
  } else {
    const allTagsData = response.data.tags;
    await localforage.setItem("allTagsData", allTagsData);
  }
};
